import * as React from 'react';

import './page-header.scss';
import CurrentPageViewers from './current-page-viewers';
import { ViewerProfile } from '@atlassian/cssxp-types-socket';

export interface PageHeaderProps {
  icon: React.ReactNode;
  header: React.ReactNode;
  subheader?: React.ReactNode;
  actions?: React.ReactNode;
  viewers?: ViewerProfile[];
}

const PageHeader = ({ icon, header, subheader, actions, viewers }: PageHeaderProps) => {
  return (
    <div className="page-header" data-testid="page-header">
      <div className="icon-container">{icon}</div>
      <hgroup>
        <h1>{header}</h1>
        {subheader && <h2>{subheader}</h2>}
      </hgroup>
      <CurrentPageViewers viewers={viewers} />
      <div className="actions-toolbar">{actions}</div>
    </div>
  );
};

export default PageHeader;
